import DeviceHealthContainer from '~/modules/devices/containers/DeviceHealthContainer';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

export default dashboardWrapper(DeviceHealthContainer, t('menu.dashboard.deviceHealth'));
